import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import CVIShipmentInsurance from './CVIShipmentInsurance';
import MotorInsurance from './MotorInsurance';
import PersonalInsurance from './PersonalInsurance';
import STIHealthInsurance from './STIHealthInsurance';



const FinancialServices = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
  
    return(
        <div>
            <div id='international' className="financial-services-image">
                <img src='/financial-services/main-banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    TCS Financial Services aims to be a unique financial services provider in Pakistan by creating 
                    internal and external strategic alliances. We offer extraordinarily customer-oriented products 
                    and creative delivery channels to build strong customer relationships. Our financial solutions 
                    serve by employing latest fintech, human resource models and forty years of market insights.
                </p>
                <p>
                Working as the sales and distribution partner for multiple insurance companies, TCS Financial 
                Services division also provides its customers with the insurance/takaful solutions suitable 
                for their needs.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="md:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/financial-services/stihealthinsurance"  className='font-bold'>Sahulat Telehealth Insurance</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/financial-services/cvishipment" className='font-bold'>Customer Voluntary Insurance</Link></li>
                            </div>

                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/financial-services/motorinsurance" className='font-bold'>Motor Insurance</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/financial-services/personalinsurance" className='font-bold'>Personal Insurance</Link></li>
                            </div>
                            
                           
                        </div>
                        
                            
                    </div>
                </div>
               
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="stihealthinsurance">
                <STIHealthInsurance />
            </div>
            <div id="cvishipment">
                <CVIShipmentInsurance />
            </div>
            <div id="motorinsurance">
                < MotorInsurance/>
            </div>
            <div id="personalinsurance">
                <PersonalInsurance />
            </div>
            </div>
            
        </div>
    )
};
export default FinancialServices;